import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BedManagementNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("/bed-management");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/bed-management",
      "/bed-management/wards",
      "/bed-management/rooms",
      "/bed-management/beds",
    ];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/bed-management");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
            }}
          >
            {[
              {
                path: "/bed-management",
                label: t("bedManagement.nav.dashboard", {
                  defaultValue: "Dashboard",
                }),
              },
              {
                path: "/bed-management/wards",
                label: t("bedManagement.nav.wards", { defaultValue: "Wards" }),
              },
              {
                path: "/bed-management/rooms",
                label: t("bedManagement.nav.rooms", { defaultValue: "Rooms" }),
              },
              {
                path: "/bed-management/beds",
                label: t("bedManagement.nav.beds", { defaultValue: "Beds" }),
              },
            ].map((tab, index) => (
              <Tab
                key={index}
                style={{
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor:
                    value === tab.path ? theme.palette.primary.main : "white",
                  color: value === tab.path ? "white" : "black",
                }}
                label={tab.label}
                value={tab.path}
                component={NavLink}
                to={tab.path}
              />
            ))}
          </Tabs>
        </Paper>
        <Box sx={{ p: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Grid>
  );
};

export default BedManagementNav;
